module.exports = __webpack_public_path__ + "img/cooperate_4.5df35175.png";